/** @format */
import { Query } from '@toucan/common/services/search/types';

import { ListingPageProps, ListingPageVariant } from '../index';

export function formatSearchFacetNumber(
    number: number | string,
    market: string
): string {
    return number
        .toString()
        .replace(/[\d.]+/g, (value) =>
            Intl.NumberFormat(market).format(parseFloat(value))
        );
}

const validateQueryObject = (queryObject: object) => {
    for (const queryParameter of Object.values(queryObject)) {
        if (typeof queryParameter === 'object') {
            if (!validateQueryObject(queryParameter)) {
                return false;
            }
        }

        const isUndefinedQueryParameter = /undefined/i.test(queryParameter);

        if (isUndefinedQueryParameter) {
            return false;
        }
    }

    return true;
};

export const validateBaseQuery = (baseQuery: Partial<Query>) => {
    if (Object.keys(baseQuery).length === 0) {
        return false;
    }

    return validateQueryObject(baseQuery);
};

export const getNumFilterSkeletons = ({
    variant,
    showProductNames,
}: Pick<ListingPageProps, 'variant' | 'showProductNames'>) => {
    const numModelFilters = 10;
    const numProductFilters = 3;

    if (variant === ListingPageVariant.MODEL || showProductNames)
        return numModelFilters;

    return numProductFilters;
};

export const shouldShowFacetCount = ({
    id,
    variant,
}: {
    id: string;
    variant: ListingPageVariant;
}) => {
    switch (variant) {
        case ListingPageVariant.MODEL:
            return !id.startsWith('product') && !/^model(\w+)Num$/.test(id);
        case ListingPageVariant.PRODUCT:
        default:
            return true;
    }
};
